module.exports = __webpack_public_path__ + "50235609bd06138782d49c84d7a39b79.png";